function formatCadenaPredio(valor) {
  if (valor.length === 7) {
    // Agrega 3 ceros a la izquierda y completa con ceros a la derecha hasta 17 caracteres
    let resultado = "000" + valor;
    return resultado.padEnd(17, "0");
  } else if (valor.length === 8) {
    // Agrega 2 ceros a la izquierda y completa con ceros a la derecha hasta 17 caracteres
    let resultado = "00" + valor;
    return resultado.padEnd(17, "0");
  } else if (valor.length === 9) {
    // Agrega 1 ceros a la izquierda y completa con ceros a la derecha hasta 17 caracteres
    let resultado = "0" + valor;
    return resultado.padEnd(17, "0");
  } else {
    // Si no es 7 u 8 u 9, retorna el valor sin cambios (puedes ajustar esto si deseas otro comportamiento)
    return valor;
  }
}

function formatDecimal(valor, fixed = 2) {
  const numero = parseFloat(valor);

  if (isNaN(numero)) {
    return "0.00"; // o podrías lanzar un error o devolver el valor original
  }

  return numero.toFixed(fixed);
}

export { formatCadenaPredio, formatDecimal };
